"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/**
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
*/
var preflight = process.env.NODE_ENV === "production" ? {
  name: "k9st3w",
  styles: "height:0;color:inherit"
} : {
  name: "1eqy3m4-preflight",
  styles: "height:0;color:inherit;label:preflight;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  preflight: preflight
};
exports.styles = styles;
//# sourceMappingURL=hr.styles.js.map